import { call, put } from 'redux-saga/effects';

import { updateSavedFilingPeriodByIdFailure } from '@actions/savedFilingPeriod';
import { updateFilingByIdRequest } from '@sagas/savedFilingPeriod/updateFilingByIdRequest';
import { toastError } from '@store/notifications';

export const handleUpdateFilingByIdRequest = function* ({ payload }) {
  try {
    yield call(updateFilingByIdRequest, { payload });
  } catch (error) {
    const { nonFieldErrors, fieldErrors } = error.data || {};

    // Use first field error as a fallback
    const errorMessage = nonFieldErrors || (fieldErrors && Object.values(fieldErrors)?.[0]);

    yield put([
      toastError({
        message: errorMessage || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      updateSavedFilingPeriodByIdFailure(error),
    ]);
    if (payload.onFailure) {
      yield call(payload.onFailure);
    }
  }
};
